import { render } from "./TokenExpired.vue?vue&type=template&id=23b1a626"
import script from "./TokenExpired.vue?vue&type=script&lang=js"
export * from "./TokenExpired.vue?vue&type=script&lang=js"

import exportComponent from "/data/tfs-agent-build/agent/_work/7/s/30-Frontend/Frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/TokenExpired.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23b1a626"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23b1a626', __exports__)) {
    api.reload('23b1a626', __exports__)
  }
  
  module.hot.accept("./TokenExpired.vue?vue&type=template&id=23b1a626", () => {
    api.rerender('23b1a626', render)
  })

}


export default __exports__